import {ReduxStateType} from '../store';

export const selectApplicableDeductions = (state: ReduxStateType) => {
  return state.applicableDeductions;
};
